/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserOptionalPatientFields } from './KinnserOptionalPatientFields';
import {
    KinnserOptionalPatientFieldsFromJSON,
    KinnserOptionalPatientFieldsFromJSONTyped,
    KinnserOptionalPatientFieldsToJSON,
    KinnserOptionalPatientFieldsToJSONTyped,
} from './KinnserOptionalPatientFields';

/**
 * WellSky field keys must come from discovery for the configured instance. Dates use mm/dd/yyyy.
 * @export
 * @interface KinnserPatientInput
 */
export interface KinnserPatientInput {
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    date_of_birth: string;
    /**
     * 
     */
    sex: KinnserPatientInputSexEnum;
    /**
     * 
     */
    residence_type: string;
    /**
     * 
     */
    hcpcs_location_code_key: string;
    /**
     * 
     */
    physician_key: string;
    /**
     * 
     */
    admission_type_key: string;
    /**
     * Optional when no episode or SOC visit is requested.
     */
    soc_date?: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    suffix?: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    address_line_one?: string;
    /**
     * 
     */
    zip_code?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    facility_key?: string;
    /**
     * 
     */
    time_zone_key?: string;
    /**
     * 
     */
    episode_start_date?: string;
    /**
     * 
     */
    optional_patient_fields?: KinnserOptionalPatientFields;
}


/**
 * @export
 */
export const KinnserPatientInputSexEnum = {
    Male: 'Male',
    Female: 'Female',
} as const;
export type KinnserPatientInputSexEnum = typeof KinnserPatientInputSexEnum[keyof typeof KinnserPatientInputSexEnum];


/**
 * Check if a given object implements the KinnserPatientInput interface.
 */
export function instanceOfKinnserPatientInput(value: object): value is KinnserPatientInput {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('date_of_birth' in value) || value['date_of_birth'] === undefined) return false;
    if (!('sex' in value) || value['sex'] === undefined) return false;
    if (!('residence_type' in value) || value['residence_type'] === undefined) return false;
    if (!('hcpcs_location_code_key' in value) || value['hcpcs_location_code_key'] === undefined) return false;
    if (!('physician_key' in value) || value['physician_key'] === undefined) return false;
    if (!('admission_type_key' in value) || value['admission_type_key'] === undefined) return false;
    return true;
}

export function KinnserPatientInputFromJSON(json: any): KinnserPatientInput {
    return KinnserPatientInputFromJSONTyped(json, false);
}

export function KinnserPatientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientInput {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'date_of_birth': json['date_of_birth'],
        'sex': json['sex'],
        'residence_type': json['residence_type'],
        'hcpcs_location_code_key': json['hcpcs_location_code_key'],
        'physician_key': json['physician_key'],
        'admission_type_key': json['admission_type_key'],
        'soc_date': json['soc_date'] == null ? undefined : json['soc_date'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'address_line_one': json['address_line_one'] == null ? undefined : json['address_line_one'],
        'zip_code': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'facility_key': json['facility_key'] == null ? undefined : json['facility_key'],
        'time_zone_key': json['time_zone_key'] == null ? undefined : json['time_zone_key'],
        'episode_start_date': json['episode_start_date'] == null ? undefined : json['episode_start_date'],
        'optional_patient_fields': json['optional_patient_fields'] == null ? undefined : KinnserOptionalPatientFieldsFromJSON(json['optional_patient_fields']),
    };
}

export function KinnserPatientInputToJSON(json: any): KinnserPatientInput {
    return KinnserPatientInputToJSONTyped(json, false);
}

export function KinnserPatientInputToJSONTyped(value?: KinnserPatientInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'date_of_birth': value['date_of_birth'],
        'sex': value['sex'],
        'residence_type': value['residence_type'],
        'hcpcs_location_code_key': value['hcpcs_location_code_key'],
        'physician_key': value['physician_key'],
        'admission_type_key': value['admission_type_key'],
        'soc_date': value['soc_date'],
        'middle_name': value['middle_name'],
        'suffix': value['suffix'],
        'ssn': value['ssn'],
        'address_line_one': value['address_line_one'],
        'zip_code': value['zip_code'],
        'city': value['city'],
        'state': value['state'],
        'phone': value['phone'],
        'email': value['email'],
        'facility_key': value['facility_key'],
        'time_zone_key': value['time_zone_key'],
        'episode_start_date': value['episode_start_date'],
        'optional_patient_fields': KinnserOptionalPatientFieldsToJSON(value['optional_patient_fields']),
    };
}

